module.exports = __webpack_public_path__ + "static/media/amazon-stars.f394d9d2.png";